/* Tudor Blog Slider: Flickity (vendors.min.js, loaded on the tudor template) + own prev / next chevrons in the gutters.
   Prev hidden at the start, next hidden at the end. Arrows move 1 slide. Re-inits on theme editor section load. */
(function () {
  var SELECTOR = '#tudor-blog-slider';

  function init(root) {
    if (!root || root.dataset.tbsReady === 'true') return;
    var list = root.querySelector('.tudor-blog-lists');
    var prev = root.querySelector('.tbs__arrow--prev');
    var next = root.querySelector('.tbs__arrow--next');
    if (!list || !list.querySelector('.tudor-blog-item-custom') || typeof window.Flickity !== 'function') return;
    root.dataset.tbsReady = 'true';

    var flkty = new window.Flickity(list, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      groupCells: false,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: false,
      dragThreshold: 10,
      selectedAttraction: 0.2,
      friction: 0.8
    });

    // With contain, the last slides share the end position: compare targets, not indexes.
    function current() {
      return flkty.selectedSlide ? flkty.selectedSlide.target : 0;
    }
    function nextIndex() {
      var cur = current();
      for (var i = 0; i < flkty.slides.length; i++) if (flkty.slides[i].target > cur + 0.5) return i;
      return -1;
    }
    function prevIndex() {
      var cur = current();
      var idx = -1;
      for (var i = 0; i < flkty.slides.length; i++) if (flkty.slides[i].target < cur - 0.5) idx = i;
      return idx;
    }

    function update() {
      if (prev) prev.hidden = prevIndex() < 0;
      if (next) next.hidden = nextIndex() < 0;
    }

    function place() {
      var image = list.querySelector('.image-box');
      var frame = root.querySelector('.tbs__frame');
      if (image && frame) {
        var y = image.getBoundingClientRect().top - frame.getBoundingClientRect().top + image.offsetHeight / 2;
        root.style.setProperty('--tbs-arrow-y', Math.round(y) + 'px');
      }
      root.style.setProperty('--tbs-gutter-px', parseFloat(getComputedStyle(root).paddingLeft) + 'px');
    }

    function go(index) {
      if (index < 0) return;
      flkty.select(index);
      update();
    }
    if (prev) prev.addEventListener('click', function () { go(prevIndex()); });
    if (next) next.addEventListener('click', function () { go(nextIndex()); });

    flkty.on('select', update);
    flkty.on('settle', update);
    flkty.on('resize', function () { place(); update(); });
    window.addEventListener('resize', place);

    place();
    update();
    root._tbsDestroy = function () {
      window.removeEventListener('resize', place);
      flkty.destroy();
      delete root.dataset.tbsReady;
    };
  }

  function start() {
    init(document.querySelector(SELECTOR));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector(SELECTOR));
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root && root._tbsDestroy) root._tbsDestroy();
  });
})();
